'use client';

import {useTranslations} from "next-intl";
import { useState } from 'react';

interface CopyToClipboardProps {
  textToCopy: string;
  children: React.ReactNode;
  toastDuration?: number;
  toastPosition?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  textToCopy,
  children,
  toastDuration = 3000,
  toastPosition = 'top-right',
}) => {
  const [toastMessage, setToastMessage] = useState<string | null>(null);

	const t = useTranslations('component.copy_to_clipboard');

  const handleCopy = () => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setToastMessage( t('success_message',  {value: textToCopy}));
        setTimeout(() => setToastMessage(null), toastDuration);
      })
      .catch(() => {
        console.error('Failed to copy text to clipboard');
      });
  };

  const toastPositionStyles: { [key: string]: React.CSSProperties } = {
    'top-left': { top: '1rem', left: '1rem' },
    'top-right': { top: '1rem', right: '1rem' },
    'bottom-left': { bottom: '1rem', left: '1rem' },
    'bottom-right': { bottom: '1rem', right: '1rem' },
  };

  return (
    <>
      <span onClick={handleCopy} style={{ cursor: 'pointer' }}>
        {children}
      </span>

      {toastMessage && (
        <div
          className="position-fixed p-3 z-index-1"
          style={{
            ...toastPositionStyles[toastPosition],
          }}
        >
          <div className="alert alert-success fade show" role="alert">
              {toastMessage}
              <button
                type="button"
                data-bs-dismiss="alert"
                className="btn-close ms-5"
                aria-label={ t('close_toast') }
                onClick={() => setToastMessage(null)}
              ></button>
          </div>
        </div>
      )}
    </>
  );
};

export default CopyToClipboard;
